import { render, staticRenderFns } from "./plan-config-form-preview.vue?vue&type=template&id=36634b94&scoped=true"
import script from "./plan-config-form-preview.vue?vue&type=script&setup=true&lang=js"
export * from "./plan-config-form-preview.vue?vue&type=script&setup=true&lang=js"
import style0 from "./plan-config-form-preview.vue?vue&type=style&index=0&id=36634b94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36634b94",
  null
  
)

export default component.exports